import LeverageCell from './LeverageCell';

export default LeverageCell;
